export const CONSULT_STEPS = [
  { id: "basic", title: "01 고객정보", tier: "basic" },
  { id: "core", title: "02 목적·규모", tier: "basic" },
  { id: "needs", title: "03 필요 기능", tier: "basic" },
  { id: "detail", title: "04 상세 상담", tier: "detail" },
  { id: "confirm", title: "05 확인", tier: "basic" },
];

export const PURPOSE_OPTIONS = [
  "회사/브랜드 소개", "서비스 소개", "문의 확보", "상담 신청", "상품 판매",
  "강의 판매", "예약", "회원 서비스", "포트폴리오", "채용", "콘텐츠 제공",
  "온라인 플랫폼", "기존 홈페이지 리뉴얼", "기타",
];

export const SCALE_OPTIONS = [
  { id: "landing", label: "단일 랜딩페이지" },
  { id: "small", label: "소형 홈페이지" },
  { id: "standard", label: "일반 기업 홈페이지" },
  { id: "functional", label: "기능형 홈페이지" },
  { id: "shop", label: "쇼핑 / 결제형" },
  { id: "booking", label: "예약형" },
  { id: "custom", label: "맞춤형 웹사이트" },
  { id: "platform", label: "플랫폼 / SaaS" },
  { id: "unknown", label: "아직 모름" },
];

export const DESIGN_ASSETS = [
  { id: "logo", label: "로고 있음" },
  { id: "ci", label: "CI / BI 있음" },
  { id: "guide", label: "브랜드 가이드 있음" },
  { id: "color", label: "사용 색상 있음" },
  { id: "font", label: "사용 폰트 있음" },
  { id: "figma", label: "Figma / 디자인 시안 있음" },
  { id: "ref", label: "참고사이트 있음" },
  { id: "none", label: "아무것도 없음" },
];

export const CONTENT_READY = [
  { id: "all_ready", label: "모두 준비됨", hint: "0원" },
  { id: "need_organize", label: "자료 정리 필요", hint: "20~40만원" },
  { id: "need_planning", label: "기획 필요", hint: "30~70만원" },
  { id: "need_copy", label: "카피 작성 필요", hint: "20~50만원" },
  { id: "need_plan_copy", label: "기획 + 카피 필요", hint: "50~100만원" },
  { id: "need_full", label: "전체 제작 필요", hint: "80~150만원+" },
];

export const CONTENT_EXTRAS = [
  { id: "ai_image", label: "AI 이미지" },
  { id: "professional", label: "전문 콘텐츠" },
  { id: "photo", label: "사진촬영" },
  { id: "video", label: "영상촬영" },
  { id: "product_photo", label: "제품촬영" },
  { id: "studio", label: "모델 / 스튜디오" },
  { id: "translation", label: "번역" },
];

export const BOARD_OPTIONS = [
  { id: "none", label: "필요 없음" }, { id: "notice", label: "공지사항" }, { id: "general", label: "일반 게시판" },
  { id: "faq", label: "FAQ" }, { id: "gallery", label: "갤러리" }, { id: "files", label: "자료실" },
  { id: "inquiry", label: "문의게시판" }, { id: "secret", label: "비밀글" }, { id: "comment", label: "댓글" },
  { id: "search", label: "검색" }, { id: "category", label: "카테고리" }, { id: "filter", label: "필터" },
  { id: "attach", label: "첨부파일" }, { id: "admin", label: "관리자 게시물 관리" }, { id: "unknown", label: "미정" },
];

export const MEMBER_OPTIONS = [
  { id: "none", label: "회원 필요 없음" }, { id: "signup_login", label: "회원가입 / 로그인" },
  { id: "signup", label: "회원가입" }, { id: "login", label: "로그인" },
  { id: "email_verify", label: "이메일 인증" }, { id: "phone_verify", label: "휴대폰 인증" },
  { id: "kakao", label: "카카오 로그인" }, { id: "naver", label: "네이버 로그인" }, { id: "google", label: "구글 로그인" },
  { id: "password_reset", label: "비밀번호 찾기" }, { id: "profile", label: "회원정보 수정" }, { id: "withdraw", label: "회원탈퇴" },
  { id: "grades", label: "회원등급" }, { id: "roles", label: "권한관리" }, { id: "admin", label: "관리자 회원관리" },
  { id: "unknown", label: "미정" },
];

export const MEMBER_BASIC_OPTIONS = [
  { id: "none", label: "회원 필요 없음" },
  { id: "signup_login", label: "회원가입 / 로그인" },
  { id: "kakao", label: "소셜 로그인" },
  { id: "unknown", label: "미정" },
];

export const MYPAGE_OPTIONS = [
  { id: "none", label: "필요 없음" }, { id: "basic", label: "기본 마이페이지" }, { id: "profile", label: "개인정보" },
  { id: "orders", label: "주문내역" }, { id: "payments", label: "결제내역" }, { id: "reservations", label: "예약내역" },
  { id: "inquiries", label: "문의내역" }, { id: "download", label: "다운로드" }, { id: "wishlist", label: "찜" },
  { id: "coupon", label: "쿠폰" }, { id: "point", label: "포인트" },
];

export const PAY_BASIC_OPTIONS = [
  { id: "none", label: "결제 없음" },
  { id: "pg", label: "온라인 결제(PG)" },
  { id: "unknown", label: "미정" },
];

export const RSV_BASIC_OPTIONS = [
  { id: "none", label: "예약 없음" },
  { id: "basic", label: "온라인 예약" },
  { id: "unknown", label: "미정" },
];

export const BOARD_BASIC_OPTIONS = [
  { id: "none", label: "필요 없음" },
  { id: "notice", label: "공지사항" },
  { id: "inquiry", label: "문의게시판" },
  { id: "general", label: "일반 게시판" },
  { id: "unknown", label: "미정" },
];

export const PAY_OPTIONS = [
  { id: "none", label: "결제 없음" }, { id: "card", label: "카드결제" }, { id: "pg", label: "PG 연동" },
  { id: "easy", label: "간편결제" }, { id: "order", label: "주문" }, { id: "history", label: "결제내역" },
  { id: "cancel", label: "취소" }, { id: "partial_cancel", label: "부분취소" }, { id: "refund", label: "환불" },
  { id: "receipt", label: "영수증" }, { id: "recurring", label: "정기결제" }, { id: "subscription", label: "구독결제" },
  { id: "guest", label: "비회원 결제" }, { id: "unknown", label: "미정" },
];

export const RSV_OPTIONS = [
  { id: "none", label: "예약 없음" }, { id: "basic", label: "기본 예약" }, { id: "date", label: "날짜" },
  { id: "time", label: "시간" }, { id: "qty", label: "인원 / 수량" }, { id: "change", label: "예약 변경" },
  { id: "cancel", label: "예약 취소" }, { id: "admin", label: "관리자 예약관리" }, { id: "plus_pg", label: "예약 + 결제" },
  { id: "staff", label: "직원별 예약" }, { id: "branch", label: "지점별 예약" }, { id: "notify", label: "예약 알림" },
  { id: "unknown", label: "미정" },
];

export const ADMIN_OPTIONS = [
  { id: "none", label: "관리자 필요 없음" }, { id: "dashboard", label: "Dashboard" }, { id: "members", label: "회원" },
  { id: "posts", label: "게시물" }, { id: "inquiries", label: "문의" }, { id: "products", label: "상품" },
  { id: "orders", label: "주문" }, { id: "reservations", label: "예약" }, { id: "payments", label: "결제" },
  { id: "roles", label: "권한" }, { id: "stats", label: "통계" }, { id: "excel", label: "Excel" }, { id: "log", label: "Log" },
];

export const CRM_OPTIONS = [
  { id: "none", label: "필요 없음" }, { id: "db", label: "고객 DB" }, { id: "consult", label: "상담내역" },
  { id: "owner", label: "담당자 배정" }, { id: "status", label: "상담 상태" }, { id: "pipeline", label: "Pipeline" },
  { id: "history", label: "History" }, { id: "search", label: "검색" }, { id: "notify", label: "알림" },
  { id: "stats", label: "통계" }, { id: "unknown", label: "미정" },
];

export const API_OPTIONS = [
  { id: "none", label: "없음" }, { id: "kakao", label: "카카오" }, { id: "naver", label: "네이버" },
  { id: "google", label: "Google" }, { id: "map", label: "지도" }, { id: "sms", label: "문자" },
  { id: "alimtalk", label: "알림톡" }, { id: "email", label: "Email" }, { id: "crm", label: "CRM" },
  { id: "erp", label: "ERP" }, { id: "accounting", label: "회계" }, { id: "external_api", label: "외부 API" },
  { id: "member_db", label: "기존 회원 DB" }, { id: "order_db", label: "기존 주문 DB" }, { id: "unknown", label: "미정" },
];

export const AI_OPTIONS = [
  { id: "none", label: "필요 없음" }, { id: "chatbot", label: "AI Chatbot" }, { id: "docs", label: "자체자료 AI" },
  { id: "autoreply", label: "AI 자동응답" }, { id: "content", label: "AI 콘텐츠" }, { id: "auto", label: "업무 자동화" },
  { id: "crm_auto", label: "CRM 자동화" }, { id: "email_auto", label: "Email 자동화" }, { id: "unknown", label: "미정" },
];

export const SEO_OPTIONS = [
  { id: "none", label: "필요 없음" }, { id: "basic", label: "기본 SEO" }, { id: "tech", label: "Technical SEO" },
  { id: "page", label: "페이지 SEO" }, { id: "meta", label: "Meta" }, { id: "sitemap", label: "Sitemap / robots" },
  { id: "gsc", label: "Search Console" }, { id: "ga4", label: "GA4" }, { id: "schema", label: "Structured Data" },
  { id: "aeo", label: "AEO" }, { id: "geo", label: "GEO" }, { id: "bundle", label: "통합" }, { id: "unknown", label: "미정" },
];

export const ASSET_ITEMS = [
  "로고", "회사소개서", "사업자정보", "서비스 설명", "상품정보", "가격정보", "사진", "영상",
  "대표자 / 직원 사진", "인증서", "특허", "수상", "이용약관", "개인정보처리방침", "환불정책",
  "기존 DB", "기존 Source", "Domain 정보", "Server 정보", "PG 정보", "API 문서", "기타",
];

export const BUDGET_OPTIONS = [
  "미정", "300만원 이하", "300~500만원", "500~1,000만원", "1,000~2,000만원", "2,000~3,000만원", "3,000만원 이상", "별도 협의",
];

export const STATUS_OPTS = [
  { id: "confirmed", label: "확정" },
  { id: "unknown", label: "미정" },
  { id: "later", label: "추후 확인" },
];

export const INTERNAL_WARNINGS = [
  "정확한 개발기간", "복잡 기능의 최종 개발비", "외부 API 연동 가능 여부", "PG 심사 승인 여부",
  "트래픽 무제한", "Server 비용 고정", "외부 서비스 무료 여부", "검색 노출 순위 보장",
  "AI 결과 정확도 보장", "기존 시스템 데이터 100% 이전 보장",
];

export const TECH_HELP = [
  { term: "PG", text: "온라인 카드결제를 처리하는 결제사 연동." },
  { term: "Backend", text: "회원, 결제, 예약 등의 데이터를 처리하는 서버." },
  { term: "Database", text: "고객, 주문, 예약 등의 정보를 저장하는 시스템." },
  { term: "CMS", text: "운영자가 홈페이지 내용을 직접 관리하는 기능." },
  { term: "CRM", text: "고객 상담 및 영업 진행상태를 관리하는 시스템." },
  { term: "API", text: "외부 서비스와 홈페이지를 연결하는 기능." },
];

export const emptyConsultation = () => ({
  company_name: "",
  contact_name: "",
  phone: "",
  email: "",
  industry: "",
  consulted_at: "",
  hoped_open: "",
  budget_range: "미정",
  memo: "",
  consultation_status: "DRAFT",
  duration_note: "",
  answers: {
    basic: { existing_url: "", ref_url: "", salesperson: "", status: "confirmed" },
    purpose: { values: [], is_new: "", pain: "", desired_action: "", status: "confirmed" },
    scale: { type: "", main_pages: "", sub_pages: "", status: "confirmed" },
    design: { assets: [], level: "", mobile: "", status: "confirmed" },
    content: { readiness: "", extras: [], status: "confirmed" },
    board: { values: [], status: "confirmed" },
    member: { values: [], status: "confirmed" },
    mypage: { values: [], status: "confirmed" },
    payment: { values: [], status: "confirmed" },
    reservation: { values: [], status: "confirmed" },
    admin: { values: [], status: "confirmed" },
    crm: { values: [], status: "confirmed" },
    integration: { values: [], api_docs: "", account: "", extra_cost: "", vendor: "", status: "confirmed" },
    ai: { values: [], status: "confirmed" },
    seo: { values: [], status: "confirmed" },
    infra: {
      domain: "", domain_owner: "", hosting: "", server: "", backend: false, database: false,
      migrate: false, ssl: false, backup: false, monitor: false, ops_payer: "미정", status: "confirmed",
    },
    maintenance: { plan: "", status: "confirmed" },
    assets: { items: {} },
    decision: { decision_maker: "", is_decider: "", extra_approver: "", design_review: "", feature_review: "", final_sign: "", quote_to: "", contract_to: "", tax_to: "", extra_contact: "" },
    legal: { sell_online: "", biz: "", mail_order: "", privacy: "", terms: "", refund: "", pg_review: "" },
  },
});
